import { Box, Text } from '@chakra-ui/react'
import { Panel, Eyebrow, tokens } from './ui'

// [divisionIndex, label] — divisionIndex selects the instruction copy and the
// conditional fields in DetailForm. Babies and Kids deliberately share index 0.
const AGE_GROUPS = [
  { value: [0, 'Babies'], label: 'Babies', range: '0–3 years' },
  { value: [0, 'Kids'], label: 'Kids', range: '4–12 years' },
  { value: [1, 'Teens'], label: 'Teens', range: '13–17 years' },
  { value: [2, 'Adults'], label: 'Adults', range: '18 and over' },
]

const ChoiceSelect = ({ setAgeGruop }) => {
  return (
    <Panel
      eyebrow="Step one"
      title="Who are you submitting?"
      containerProps={{ maxW: '760px', mx: 'auto' }}
    >
      <Text fontSize="15px" color={tokens.muted} lineHeight="1.6" mb={7}>
        Choose an age group to see the submission requirements for that division.
      </Text>

      <Box
        display="grid"
        gridTemplateColumns={{ base: '1fr', sm: '1fr 1fr' }}
        gridGap={3}
      >
        {AGE_GROUPS.map(({ value, label, range }) => (
          <Box
            key={label}
            as="button"
            type="button"
            textAlign="left"
            onClick={() => { setAgeGruop(value) }}
            bg="white"
            borderWidth="1px"
            borderColor={tokens.line}
            borderRadius="14px"
            px={6}
            py={6}
            transition="border-color .16s, background .16s, transform .16s"
            _hover={{ borderColor: tokens.green, bg: tokens.greenTint }}
            _focusVisible={{
              outline: `2px solid ${tokens.green}`,
              outlineOffset: '3px',
            }}
            _active={{ transform: 'translateY(1px)' }}
          >
            <Text
              fontSize="26px"
              lineHeight="1.1"
              color={tokens.ink}
              mb="8px"
            >
              {label}
            </Text>
            <Eyebrow color={tokens.muted}>{range}</Eyebrow>
          </Box>
        ))}
      </Box>
    </Panel>
  )
}

export default ChoiceSelect
